import {MailVerificationRequest} from '../ui/MailVerificationRequest';
import {createRoot} from 'react-dom/client';
import {publicMailRoute} from './public-mail-route';
import {MailReminderConfirmation} from '../ui/MailReminderConfirmation';
import {MailUnsubscribeConfirmation} from '../ui/MailUnsubscribeConfirmation';

/** Call from a tiny bootstrap BEFORE dynamically importing the product entry.
 * Returns false for ordinary routes; then the caller imports the normal app.
 * This module must stay independent of the canonical client and Auth providers.
 * Public exits and back/forward use document navigation to re-run bootstrap. */
export function mountPublicMailEntry(element:HTMLElement,projectUrl:string,href=window.location.href):boolean {
 const route=publicMailRoute(href);
 if(!route)return false;
 window.addEventListener('popstate', () => window.location.reload(), {once:true});
 createRoot(element).render(route==='verification'
  ? <MailVerificationRequest projectUrl={projectUrl}/>
  : route==='reminder'
  ? <MailReminderConfirmation projectUrl={projectUrl}/>
  : <MailUnsubscribeConfirmation projectUrl={projectUrl}/>);
 return true;
}
